import { render, staticRenderFns } from "./trans.vue?vue&type=template&id=656cd994&scoped=true&"
import script from "./trans.vue?vue&type=script&lang=js&"
export * from "./trans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656cd994",
  null
  
)

export default component.exports